import React from 'react';
import { ErrorBoundary as ErrorBoundaryComponent, FallbackProps } from 'react-error-boundary';

import { useTranslations } from '@core/js/hooks/i18n';
import { useIsAdmin } from '@core/js/hooks/user';

const ErrorFallback: React.FC<FallbackProps> = ({ error }) => {
    const isAdmin = useIsAdmin();
    const t = useTranslations('playtech.mobile.system.error.');

    if (!isAdmin) {
        return null;
    }

    return (
        <>
            <h2>{t('default')}</h2>

            <pre>{error.message}</pre>
        </>
    );
};

export const ErrorBoundary: React.FC = ({ children }) => (
    <ErrorBoundaryComponent
        FallbackComponent={ErrorFallback}
    >
        {children}
    </ErrorBoundaryComponent>
);
